import axios from 'axios'
import Router from "@/router"
import {
  store
} from '@/store'
import {
  getUser
} from '@/libs/auth'

// import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API_BASE_URL : window.APIURL.rootUrl, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // 请求超时15秒
})

// request interceptor 请求时拦截器
service.interceptors.request.use(
  config => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    var user = getUser();
    if (user !== undefined && user != null) {
      config.headers.Authorization = 'bearer ' + user.token;
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor 返回响应时拦截器
service.interceptors.response.use(
  response => {
    //如果带有分页的header，返回完整的响应，否则只返回data部分；
    if (response.headers["paging-headers"]) {
      return response;
    } else {
      const res = response.data;
      return res;
    }
  },
  error => {
    //console.log(error) // for debug
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          Router.push({
            path: '/login',
            query: {
              redirect: Router.currentRoute.fullPath
            }
          });
          break;
        case 500:
          break;
      }
    }
    return Promise.reject(error)
    //return Promise.resolve(error); //表示异常已处理
  }
)

export default service